import { CustomerSettingValueType, SmartSendSettingsModel } from '~/lib/api/me/types';
import { SmartSendSettings } from './smart-send-settings';

export interface props {
  saving: boolean;
  name: string;
  value: CustomerSettingValueType;
  wrapper: (x: JSX.Element) => JSX.Element;
  onSave?: (name: string, value: CustomerSettingValueType) => void;
  onUserDismiss?: (name: string) => void;
  hideDetails?: boolean;
}

const Setting = ({ onUserDismiss, hideDetails, name, value, wrapper, onSave, saving }: props) => {
  switch (name) {
    case 'SmartSendSettings':
      return wrapper(
        <SmartSendSettings
          onUserDismiss={onUserDismiss ? () => onUserDismiss(name) : undefined}
          name={name}
          saving={saving}
          value={value as SmartSendSettingsModel}
          onSave={(v) => onSave(name, v)}
          hideDetails={hideDetails}
        />
      );

    default:
      return null;
  }
};

export default Setting;
